/*@ngInject*/
const SplitSubmissionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.splitSubmission = function (submissionId, productShortNames) {
        var productShortNameString = '',
            url = '',
            str = '',
            config;

        _.each(productShortNames, function (productShortName) {
            str = productShortNameString !== '' ? '&' : '';
            productShortNameString += str + 'productShortName=' + productShortName;
        });
        url = '/rest/Submission/' + submissionId + '/splitSubmission?' + productShortNameString,
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('splitSubmissionRepository', SplitSubmissionRepository);
